import React, { useState, useRef, useEffect } from 'react'
import { useHistory, useParams, Link } from 'react-router-dom'
import {
  HttpService,
  API,
  SimpleReactValidator,
  Title,
  toast,
  Messages,
  Spinner
} from '../../../config/react'

const AddRole = () => {
  const urlParams = useParams()
  const history = useHistory()
  const submitbtnRef = useRef()
  const [IsAuth, setIsAuth] = useState(false)
  const [loading, setLoading] = useState(true)
  const validator = useRef(new SimpleReactValidator())
  const [isForceUpdate, setForceUpdate] = useState(false)
  const [PermissionList, setPermissionList] = useState([])
  const [Inputs, setInputs] = useState({
    id: 0,
    name: '',
    permissions: [],
    status: 0
  })

  useEffect(() => {
    setIsAuth(true)
    document.title = Title.AddRole
    if (urlParams.id != null) {
      document.title = Title.EditRole
      GetRolebyID()
    }
    GetPermissionList()
  }, [urlParams.id])

  const GetRolebyID = () => {
    const param = {
      id: urlParams.id
    }
    setLoading(true)
    HttpService.postApi(API.GetRoleByID, param).then((response) => {
      setLoading(false)
      if (response.data.result) {
        setInputs(response.data.result[0][0])
        setForceUpdate(!isForceUpdate)
      }
    })
  }
  const GetPermissionList = () => {
    setLoading(true)
    HttpService.getApi(API.GetPermission).then((response) => {
      setLoading(false)
      if (response.data.status === true) {
        const data = response.data.result[0]
        setPermissionList(data)
        setForceUpdate(!isForceUpdate)
      }
    })
  }

  const handleInputChanges = (prop) => (event) => {
    if (prop === 'status') {
      setInputs({ ...Inputs, [prop]: event.target.checked })
    } else if (prop === 'permissions') {
      const target = event.target
      const value = target.value
      if (target.checked) {
        Inputs.permissions.push(parseInt(value))
      } else {
        Inputs.permissions = Inputs.permissions.filter((e) => e !== parseInt(value))
      }
    } else {
      setInputs({ ...Inputs, [prop]: event.target.value })
    }
    setForceUpdate(!isForceUpdate)
  }

  const SubmitForm = (e) => {
    if (!validator.current.allValid()) {
      validator.current.showMessages()
      setForceUpdate(!isForceUpdate)
      return
    }

    // if (submitbtnRef.current)
    //     submitbtnRef.current.setAttribute("disabled", "disabled");

    const param = {
      _id: Inputs.id,
      _name: Inputs.name,
      _permission: Inputs.permissions
    }
    setLoading(true)
    HttpService.postApi(API.SetRole, param).then((response) => {
      setLoading(false)
      if (response.data.message) {
        toast.warning(response.data.message)
        setForceUpdate(!isForceUpdate)
        submitbtnRef.current.removeAttribute('disabled')
        return
      }
      if (urlParams.id !== undefined) toast.success(Messages.RecordAdded)
      else toast.success(Messages.RecordUpdated)
      setForceUpdate(!isForceUpdate)
      history.push('/roles')
    })
  }

  return !IsAuth || loading ? (
    <Spinner />
  ) : (
    <div className="content-wrapper pb-0">
      <div className="page-header">
        <h3 className="page-title mb-0">
          {' '}
          {urlParams.id !== undefined ? Title.EditRole : Title.AddRole}{' '}
        </h3>
        <div className="btn-group">
          <button
            type="button"
            className="btn btn-dark btn-fw rounded mr-2"
            onClick={history.goBack}
          >
            {' '}
            Back{' '}
          </button>
        </div>
      </div>
      <div className="row">
        <div className="col-12 grid-margin stretch-card">
          <div className="card">
            <div className="card-body">
              <form className="forms-sample">
                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group">
                      <label>Name</label>
                      <input
                        type="text"
                        className="form-control"
                        name="name"
                        onChange={handleInputChanges('name')}
                        onKeyUp={handleInputChanges('name')}
                        onBlur={() => validator.current.showMessageFor('Name')}
                        value={Inputs.name}
                        placeholder="Name"
                      />
                      {validator.current.message('Name', Inputs.name, 'required|alpha_num_space', {
                        className: 'error'
                      })}
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-12 grid-margin stretch-card">
          <div className="card">
            <div className="card-header">
              <h5 className="page-title"> {Title.Permissions} </h5>
            </div>
            <div className="card-body">
              <form className="forms-sample">
                <div className="row">
                  {PermissionList.length > 0
                    ? PermissionList.map((item, index) => (
                        <div
                          className="col-md-3"
                          key={index}
                        >
                          <div className="form-group">
                            <input
                              type="checkbox"
                              className="mr-2 pointer"
                              name="permissions"
                              onChange={handleInputChanges('permissions')}
                              value={item.id}
                              checked={Inputs.permissions.includes(item.id)}
                              id={'permission_' + item.id}
                            />
                            <label
                              className="mt-1 pointer"
                              htmlFor={'permission_' + item.id}
                            >
                              {item.name}
                            </label>
                          </div>
                        </div>
                      ))
                    : ''}
                </div>
                <div className="row">
                  {validator.current.message('Permission', Inputs.permissions, 'required', {
                    className: 'error'
                  })}
                </div>
              </form>
              <div className="row">
                <div className="col-md-6">
                  <button
                    ref={submitbtnRef}
                    type="button"
                    onClick={SubmitForm}
                    className="btn btn-custom text-white mr-2 "
                  >
                    {' '}
                    Submit{' '}
                  </button>
                  <Link
                    to="/roles"
                    className="btn btn-primary"
                  >
                    Cancel
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default AddRole
